
import image1 from './images/Image-1.jpg'
import image3 from './images/image-3.jpeg'
import userHomeIcon from './images/user-home-icon.png'
import oldMan from './images/old-man.jpeg'
import george from './images/george.jpeg'
import penguin from './images/penguin-bbok.jpeg'
import fbook1 from './frontImages/fbook1.jpg'
import fbook2 from './frontImages/fbook2.jpg'
import fbook3 from './frontImages/fbook3.jpg'
import fbook4 from './frontImages/fbook4.jpg'
import fbook5 from './frontImages/fbook5.jpg'
import fbook6 from './frontImages/fbook6.jpg'
import fbook7 from './frontImages/fbook7.jpg'
import fbook8 from './frontImages/fbook8.jpg'
import fbook9 from './frontImages/fbook9.jpg'
import fbook10 from './frontImages/fbook10.jpg'
import fbook11 from './frontImages/fbook11.jpg'
import fbook12 from './frontImages/fbook12.jpg'
import fbook13 from './frontImages/fbook13.jpg'
import fbook14 from './frontImages/fbook14.jpg'
import fbook15 from './frontImages/fbook15.jpg'
import fbook16 from './frontImages/fbook16.jpg'
import fbook17 from './frontImages/fbook17.jpg'
import fbook18 from './frontImages/fbook18.jpg'
import imgHome1 from './home-grid-images/img-home-1.jpg'
import imgHome2 from './home-grid-images/img-home-2.jpg'
import imgHome3 from './home-grid-images/img-home-3.jpg'
import imgHome4 from './home-grid-images/img-home-4.jpg'
import imgHome5 from './home-grid-images/img-home-5.jpg'
import imgHome6 from './home-grid-images/img-home-6.jpg'
import imgHome7 from './home-grid-images/img-home-7.jpg'

export const assets = {
    image1,
    image3,
    userHomeIcon,
    oldMan,
    george,
    penguin,
    fbook1,
    fbook2,
    fbook3,
    fbook4,
    fbook5,
    fbook6,
    fbook7,
    fbook8,
    fbook9,
    fbook10,
    fbook11,
    fbook12,
    fbook13,
    fbook14,
    fbook15,
    fbook16,
    fbook17,
    fbook18,
    imgHome1,
    imgHome2,
    imgHome3,
    imgHome4,
    imgHome5,
    imgHome6,
    imgHome7,
}


